<script setup lang="ts">
    import { __ } from '@/js/stores/expressions';
    import { SettingsIcon } from '@lucide/vue';
    import SubNavigationLink from './SubNavigationLink.vue';
    import SubNavigationLinkDropdown from './SubNavigationLinkDropdown.vue';
    import { usePermissions } from '@/js/composables/usePermissions';
    import {
        PermissionArea,
        QualityAssuranceModulePermissionFlag,
        UserManagementPermissionFlag,
        RoleManagementPermissionFlag,
    } from '@/js/consts/permissions';
    import { computed } from 'vue';

    const { hasPermission } = usePermissions();

    const canAccessQA = hasPermission(
        PermissionArea.QualityAssuranceModule,
        QualityAssuranceModulePermissionFlag.Access
    );
    const canCreateForm = hasPermission(
        PermissionArea.QualityAssuranceModule,
        QualityAssuranceModulePermissionFlag.CreateForm
    );
    const canScheduleCoaching = hasPermission(
        PermissionArea.QualityAssuranceModule,
        QualityAssuranceModulePermissionFlag.ScheduleCoaching
    );
    const canManageUsers = hasPermission(
        PermissionArea.UserManagement,
        UserManagementPermissionFlag.Access
    );
    const canManageRoles = hasPermission(
        PermissionArea.RoleManagement,
        RoleManagementPermissionFlag.Access
    );

    const showQualityAssuranceDropdown = computed(() => {
        return canAccessQA.value && (canCreateForm.value || canScheduleCoaching.value);
    });
</script>
<template>
    <div class="w-full h-full py-6 px-3">
        <nav :aria-label="__('settings-sub-navigation')">
            <div class="flex gap-2 mb-5 px-3">
                <SettingsIcon class="size-5 self-start mt-1" />
                <h2 class="heading-md">
                    {{ __('settings') }}
                </h2>
            </div>
            <ul class="flex flex-col gap-1">
                <li>
                    <SubNavigationLink :to="'/settings/general'">
                        {{ __('settings-general') }}
                    </SubNavigationLink>
                </li>

                <SubNavigationLinkDropdown
                    v-if="showQualityAssuranceDropdown"
                    :label="__('quality-assurance')"
                >
                    <li v-if="canCreateForm">
                        <SubNavigationLink :to="'/settings/manage-forms'">
                            {{ __('settings-manage-forms') }}
                        </SubNavigationLink>
                    </li>
                    <li v-if="canScheduleCoaching">
                        <SubNavigationLink :to="'/settings/schedule-forms'">
                            {{ __('settings-schedule-forms') }}
                        </SubNavigationLink>
                    </li>
                </SubNavigationLinkDropdown>

                <li v-if="canManageUsers">
                    <SubNavigationLink :to="'/settings/manage-users'">
                        {{ __('settings-manage-users') }}
                    </SubNavigationLink>
                </li>

                <li v-if="canManageRoles">
                    <SubNavigationLink :to="'/settings/manage-roles'">
                        {{ __('settings-manage-roles') }}
                    </SubNavigationLink>
                </li>
            </ul>
        </nav>
    </div>
</template>
